// @ts-strict-ignore
import { css } from 'styled-components';

import { bp, breakpoints } from 'theme';

const mediaQueries = {
  xs: `(max-width: ${breakpoints[0]})`,
  sm: `(min-width: ${breakpoints[0]}) and (max-width: ${breakpoints[2]})`,
  md: `(min-width: ${breakpoints[2]}) and (max-width: ${breakpoints[2]})`,
  lg: `(min-width: ${breakpoints[2]}) and (max-width: ${breakpoints[3]})`,
  xl: `(min-width: ${breakpoints[3]})`,
};
export const media = Object.keys(mediaQueries).reduce((acc, label) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line no-param-reassign
  acc[label] = (...args: never) => css`
    @media ${mediaQueries[label]} {
      ${
        // @ts-expect-error Fix types
        css(...args)
      };
    }
  `;

  return acc;
}, {});

const generateMediaQuery = ({
  xs,
  sm,
  md,
  lg,
  xl,
}: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}) =>
  [
    xs && `(max-width: ${breakpoints[0]})`,
    sm && `(min-width: ${breakpoints[0]}) and (max-width: ${bp[1] + 1}px)`,
    md && `(min-width: ${breakpoints[1]}) and (max-width: ${bp[2] + 1}px)`,
    lg && `(min-width: ${breakpoints[2]}) and (max-width: ${bp[3] + 1}px)`,
    xl && `(min-width: ${breakpoints[3]})`,
  ]
    .filter(Boolean)
    .join();

export const matchSize = (sizes: {
  xs?: boolean;
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
}) =>
  typeof window === 'object'
    ? window.matchMedia(generateMediaQuery(sizes)).matches
    : false;
